import TaxCodeApi from "./TaxCodeApi";

export default TaxCodeApi;